<template>
    <el-card class="card">
        <template v-slot:header>
            <div class="clearfix">
                <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>TF Number</span>
            </div>
        </template>
        <div>
            <div ref="areaChart" style="width: 100%; height: 400px;"></div>
        </div>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            url: "http://183.175.59.4/devenhancer/",
            endpoint: "Commonen",
            chartData: [],
            uniqueTissues: [],
            xAxisData: [], // 添加 xAxisData 以存储组织名
            yAxisData: [], // 修改为数组
            barColors: [], // 新增柱子颜色数组
            lineColors: [], // 新增折线颜色数组
        };
    },
    props: {
        species: {
            type: String,
            required: true,
        },
        tissue: {
            type: [String, Array],
            required: true,
        },
        tf: {
            type: String,
            required: true,
        },
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const params = {
                Species: this.species,
                Tissue: this.tissue,
                Tfbs: this.tf,
            };

            this.$axios.get(`${this.url}${this.endpoint}/`, { params })
                .then(response => {
                    this.chartData = response.data;
                    this.extractChartData(); // 添加提取 Tissue 的函数
                    this.generateRandomColors(); // 新增生成随机颜色的函数
                    this.renderChart();
                })
                .catch(error => {
                    console.error('获取数据时出错:', error);
                });
        },
        // 修改 extractChartData 方法
        extractChartData() {
            // 获取后端传递的组织名数组
            const backendTissues = Array.from(new Set(this.chartData.map(item => item.Tissue)))
                .sort((a, b) => this.tissue.indexOf(a) - this.tissue.indexOf(b));

            // 将后端没有传递的组织名添加到 xAxisData 中，对应的 yAxisData 设置为 0
            for (const tissue of this.tissue) {
                if (!backendTissues.includes(tissue)) {
                    this.xAxisData.push(tissue);
                    this.yAxisData.push(0);
                }
            }

            // 将后端传递的组织名添加到 xAxisData 中
            this.xAxisData = this.xAxisData.concat(backendTissues);

            // 对 xAxisData 进行排序
            this.xAxisData.sort((a, b) => this.tissue.indexOf(a) - this.tissue.indexOf(b));

            // 更新 yAxisData
            this.yAxisData = this.xAxisData.map(tissue => {
                const uniqueCoreids = new Set(this.chartData.filter(item => item.Tissue === tissue).map(item => item.Coreid));
                return uniqueCoreids.size;
            });
        },

        generateRandomColors() {
            // 生成随机颜色
            const randomColors = Array.from({ length: this.yAxisData.length }, () =>
                `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`
            );

            this.barColors = randomColors;

            // 生成随机颜色用于折线图
            const lineColors = Array.from({ length: this.yAxisData.length }, () =>
                `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`
            );

            this.lineColors = lineColors;
        },
        renderChart() {
            const chart = this.$echarts.init(this.$refs.areaChart);

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        },
                    }
                },
                xAxis: {
                    type: 'category',
                    data: this.xAxisData, // 使用提取的组织名作为X轴
                    axisLabel: {
                        show: true,
                        interval: 0,
                        rotate: 0, // 设置斜体展示
                        fontSize: 10, // 设置字体大小为8
                    },
                },
                yAxis: {
                    type: 'value',
                    name: 'number of TF', // 修改Y轴名称
                },
                series: [
                    {
                        type: 'bar',
                        data: this.yAxisData, // 使用提取的数据作为Y轴
                        itemStyle: {
                            color: params => this.barColors[params.dataIndex], // 设置柱子颜色
                        },
                        barWidth: 30, // 设置柱子宽度，根据实际需要调整
                    },
                    {
                        type: 'line', // 添加折线图
                        data: this.yAxisData, // 使用提取的数据作为折线图的Y轴
                        smooth: true, // 设置折线平滑
                        lineStyle: {
                            color: params => this.lineColors[params.dataIndex], // 设置折线颜色
                        },
                    },
                ],
            };

            chart.setOption(option);
        },
    },
};
</script>

<style scoped>
.card{
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Tffig.vue